import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import FlashMessageContent from './FlashMessageContent';

import styles from './flashMessage.scss';

export function FlashMessage({ type, text }) {
    return (
        <div styleName="wrapper">
            <FlashMessageContent type={type} text={text} />
        </div>
    );
}

FlashMessage.propTypes = {
    type: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
};

export default CSSModules(FlashMessage, styles, { allowMultiple: true });
